import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import type {
  APIResponse,
  MatterIncidentReportData,
  SourceOwnedConnectionCreate,
} from "@/lib/types";

const incidentReportPayloadKeys = [
  "dateModified",
  "description",
  "fileNumber",
  "id",
  "matterId",
  "noReport",
  "notApplicable",
  "sentiment",
  "status",
  "time",
] as const;

const getMatterIncidentReportPayload = (
  data: Partial<MatterIncidentReportData>,
): Partial<MatterIncidentReportData> =>
  Object.fromEntries(
    incidentReportPayloadKeys
      .filter((key) => key in data)
      .map((key) => [
        key,
        key === "fileNumber" &&
        typeof data[key] === "string" &&
        data[key].trim() === ""
          ? null
          : data[key],
      ]),
  ) as Partial<MatterIncidentReportData>;

export type CreateMatterIncidentReportV3Input = Pick<
  MatterIncidentReportData,
  "matterId"
> &
  Partial<MatterIncidentReportData> & {
    connections?: SourceOwnedConnectionCreate[];
  };

export const createMatterIncidentReportV3 = (
  data: CreateMatterIncidentReportV3Input,
) => {
  const { connections = [], ...reportData } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<
      APIResponse<MatterIncidentReportData>
    >("matters/v4/incident-reports", { ...getMatterIncidentReportPayload(reportData), connections })
    .then((res) => res.data);
};

export const updateMatterIncidentReportV1 = (
  data: Pick<MatterIncidentReportData, "id" | "matterId" | "dateModified"> &
    Partial<MatterIncidentReportData>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MatterIncidentReportData>
    >(`${baseFastApiMatterRoute}/incident-reports`, getMatterIncidentReportPayload(data))
    .then((res) => res.data);
};

export const deleteMatterIncidentReportV1 = (
  data: Pick<MatterIncidentReportData, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterIncidentReportData>
    >(`${baseFastApiMatterRoute}/incident-reports/${id}`)
    .then((res) => res.data);
};
